module.exports = __webpack_public_path__ + "img/8.11feb253.svg";